import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../../services/api";
import InvoiceForm from "../../components/Invoices/InvoiceForm";
import { t } from "@lingui/macro";

const EMPTY_RECEIVER = {
  name: "",
  rfc: "",
  cfdiUse: "",
  fiscalRegime: "",
  taxZipCode: "",
};

const InvoiceFixPage = () => {
  const { invoiceRequestId } = useParams();

  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [receiver, setReceiver] = useState(EMPTY_RECEIVER);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!invoiceRequestId) {
      setLoading(false);
      return;
    }

    const loadStatus = async () => {
      try {
        const response = await API.get(
          `/api/invoices/public/${invoiceRequestId}/status`
        );

        setStatus(response.data.status);
        setErrorMessage(response.data.errorMessage || "");

        setReceiver({
          ...EMPTY_RECEIVER,
          ...(response.data.receiver || {}),
        });
      } catch (err) {
        setErrorMessage(t`Invoice not found.`);
      } finally {
        setLoading(false);
      }
    };

    loadStatus();
  }, [invoiceRequestId]);

  const handleSubmit = async () => {
    try {
      await API.put(
        `/api/invoices/public/${invoiceRequestId}/receiver`,
        receiver
      );
      setSuccess(true);
    } catch (err) {
      setErrorMessage(t`Could not save invoice data. Please try again.`);
    }
  };

  if (!invoiceRequestId) {
    return (
      <div style={{ textAlign: "center", marginTop: "2rem" }}>
        <h2>{t`Invalid invoice link`}</h2>
        <p>{t`Please check the link you received by email.`}</p>
      </div>
    );
  }

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "2rem" }}>
        <p>{t`Loading invoice details...`}</p>
      </div>
    );
  }

  if (success) {
    return (
      <div style={{ textAlign: "center", marginTop: "2rem" }}>
        <h2>{t`Thank you!`}</h2>
        <p>{t`Your invoice is being generated.`}</p>
        <p>{t`You will receive it by email shortly.`}</p>
      </div>
    );
  }

  if (status === "ISSUED") {
    return (
      <div style={{ textAlign: "center", marginTop: "2rem" }}>
        <h2>{t`Invoice already issued`}</h2>
        <p>{t`Your invoice has already been generated and sent by email.`}</p>
      </div>
    );
  }

  if (status === "PENDING") {
    return (
      <div style={{ textAlign: "center", marginTop: "2rem" }}>
        <h2>{t`Invoice is being processed`}</h2>
        <p>{t`Please wait a moment. You will receive it by email.`}</p>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: "600px", margin: "2rem auto" }}>
      <h2>{t`Fix invoice details`}</h2>

      <div
        style={{
          background: "#fdecea",
          color: "#611a15",
          padding: "1rem",
          marginBottom: "1rem",
          borderRadius: "4px",
        }}
      >
        <strong>{t`There was a problem with your invoice:`}</strong>
        <div>{errorMessage}</div>
      </div>

      <InvoiceForm receiver={receiver} setReceiver={setReceiver} />

      <div style={{ marginTop: "1.5rem", textAlign: "center" }}>
        <button className="add-new-btn" onClick={handleSubmit}>
          {t`Save and generate invoice`}
        </button>
      </div>
    </div>
  );
};

export default InvoiceFixPage;
